<template>
    <div class="fullcontainer p1bg">
      <Back2FirstPage picposcls="picpos" />
      <MusicIcon picposcls="musicpos" />

      <img class="ycyjs" src="res/p3/ccyjstyzl.png">
      
      <img v-if="silent" class="djjr heartpulse" src="res/p3/djjr.png" @click="onClick">
      
       <AnimatePlayer v-if="!silent" animateKey="jgc" @loop="onLoop"/>
       
    </div> 
</template>

<script>
// import { canvasAniExt } from "@/d";
import Back2FirstPage from "./Back2FirstPage";
import MusicIcon from "./MusicIcon";
import AnimatePlayer from "./AnimatePlayer";

// import { CONFS } from "./animateconf";

let silent = false;

const components = { Back2FirstPage, MusicIcon, AnimatePlayer };
export default {
  data() {
    return {
      silent,
    };
  },

  mounted() {

  },
  beforeDestroy() {
    clearTimeout(this.timeId);
  },

  methods: {
    onLoop(){
      this.timeId = setTimeout(() => {
         silent = this.silent = true;
      }, 800);
    },
    onClick() {
      this.$root.$emit('P3SwitchTo','P3_2');
      this.$root.$emit('pause_animate_audio');
    }
  },

  components
  // extends:canvasAniExt(),
};
</script>

<style lang="scss">
@import "D:/workspace/all_web/src/_cmm/css/centerbg.scss";
@import "D:/workspace/all_web/src/_cmm/css/horizontalCenterPercent.scss";

.p1bg {
  // @include centerbg; //'res/p1/bg.png'
  // background: url("../../public/res/p1/bg.png");
  .ycyjs {
    @include horizontalCenterPercent(32%);
    top: 12%;
  }

  .djjr {
    @include horizontalCenterPercent(60%);
    bottom: 20%;
  }
}
</style>
